import { UrlApi } from "../../../../../services/apirest";

export const getObservaciones = async (empresa) => {
  try {
    const response = await fetch(
      `${UrlApi}/envasado_conciliacion_observaciones/empresa/${empresa}`,
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error al obtener observaciones:', error);
    throw error;
  }
};

export const guardarObservacion = async (data) => {
  try {
    const user = localStorage.getItem('user');

    const response = await fetch(`${UrlApi}/envasado_conciliacion_observaciones/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...data,
        usuario: user || 'sistema',
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || `Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error al guardar observación:', error);
    throw error;
  }
};

export const eliminarObservacion = async (id) => {
  try {
    const response = await fetch(`${UrlApi}/envasado_conciliacion_observaciones/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error al eliminar observación:', error);
    throw error;
  }
};
